import { defineMessages } from 'react-intl'

export const plannerMessages = defineMessages({
  avoidHighways: {
    id: 'Sidebar.avoidHighways',
    defaultMessage: 'Avoid Highways'
  }
})
